package ui.screens.section.weddinginfo

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import kotlinx.coroutines.delay
import kotlinx.coroutines.isActive
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant
import ui.theme.ColorScheme
import kotlin.time.Clock
import kotlin.time.Duration
import kotlin.time.Duration.Companion.hours
import kotlin.time.Duration.Companion.seconds
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

private val JakartaTimeZone = TimeZone.of("UTC+07:00")

@OptIn(ExperimentalTime::class)
@Composable
fun CountdownWedding(
    year: Int,
    month: Int,
    day: Int,
    hour: Int,
    minute: Int,
    modifier: Modifier = Modifier,
) {

    // 🔥 Target hanya dihitung sekali
    val targetInstant = remember {
        LocalDateTime(year, month, day, hour, minute)
            .toInstant(JakartaTimeZone)
    }

    var now by remember { mutableStateOf(Clock.System.now()) }

    // 🔥 Tick sinkron ke sistem clock (anti drift)
    LaunchedEffect(Unit) {
        while (isActive) {
            val current = Clock.System.now()
            val millisUntilNextSecond =
                1000 - (current.toEpochMilliseconds() % 1000)

            delay(millisUntilNextSecond)
            now = Clock.System.now()
        }
    }

    // 🔥 Derived state supaya perhitungan tidak berat
    val remainingSeconds by remember {
        derivedStateOf {
            (targetInstant - now)
                .coerceAtLeast(Duration.ZERO)
                .inWholeSeconds
        }
    }

    CountdownRow(
        remainingSeconds = remainingSeconds,
        modifier = modifier
    )
}

@Composable
private fun CountdownRow(
    remainingSeconds: Long,
    modifier: Modifier = Modifier,
) {
    val days = remainingSeconds / 86_400
    val hours = (remainingSeconds % 86_400) / 3_600
    val minutes = (remainingSeconds % 3_600) / 60
    val seconds = remainingSeconds % 60

    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(12.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        TimeBox(days, "Hari")
        TimeBox(hours, "Jam")
        TimeBox(minutes, "Menit")
        TimeBox(seconds, "Detik")
    }
}

@Composable
fun TimeBox(
    value: Long,
    label: String,
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier
            .background(Color.White, RoundedCornerShape(16.dp))
            .padding(vertical = 12.dp, horizontal = 20.dp)
    ) {
        Text(
            text = value.toString().padStart(2, '0'),
            fontSize = 28.sp,
            fontWeight = FontWeight.Bold,
            color = ColorScheme.primary
        )
        Spacer(Modifier.height(4.dp))
        Text(
            text = label,
            fontSize = 14.sp,
            fontWeight = FontWeight.Medium,
            color = Color(0xff323232)
        )
    }
}